import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import TextButton from "@components/TextButton";
import Typography from "@components/Typography";

import Message from "./Message";

const FilteredEmpty = ({ v4 = false }: { v4?: boolean }) => {
  const [{ tag }, setFilters] = useFilterParams();
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;

  return (
    <Message data-testid="filter-no-mentions">
      <Typography variant="h6" align="center">
        {L.ALERT_NO_MENTIONS}
        <br />
        <TextButton
          onClick={(e: unknown) => {
            (e as MouseEvent).preventDefault();
            setFilters(
              { tag, start_date: tag ? undefined : alert?.start_date },
              true
            );
          }}
        >
          {L.ALERT_NO_MENTIONS_FILTERED}
        </TextButton>
      </Typography>
    </Message>
  );
};
export default FilteredEmpty;
